const HelpUrls = {
  HowToSetupBankFeedUrl: "https://help.myob.com/wiki/display/myob/Setting+up+bank+feeds",
  HowToFixBankFeedConnectionErrorUrl: "https://help.myob.com/wiki/display/GEN/DRAFT+Bank+feeds+connection+errors",
  GetHelpSettingUpBankUrl: "https://help.myob.com/openbanking/{page}/{product}/{bankName}",
};

export default HelpUrls;

const productMap = {
  SMEP: "myobbusiness",
  Solo: "solo"
};

export const formatUrl = (url, consumerId, productPage, bankName) => {
  let product = productMap[consumerId] || consumerId;

  return url.replace("{product}", product)
    .replace("{page}", productPage || "")
    .replace("/{bankName}", bankName ? `/${bankName}` : "");
}
